import { ADD_TO_CART_PRODUCTS, GET_ALL_PRODUCTS, UPDATE_PRODUCT, UPDATE_PRODUCT_FAILED, UPDATE_PRODUCT_REQUEST } from '../action.type';
const intialState = {
  producLoader: true,
  updateProducLoader: false,
  allProducts: null,
  atcProduct: null,
};

export const catelogReducer = (state = intialState, action) => {
  switch (action.type) {
    case GET_ALL_PRODUCTS:
      return {
        ...state,
        producLoader: false,
        allProducts: action.payload,
      };
    case ADD_TO_CART_PRODUCTS:
      return {
        ...state,
        producLoader: false,
        atcProduct: action.payload,
      };
    case UPDATE_PRODUCT_REQUEST:
      return {
        ...state,
        producLoader: false,
        updateProducLoader: true,
        atcProduct: action.payload,
      };
    case UPDATE_PRODUCT:
      return {
        ...state,
        producLoader: false,
        updateProducLoader: false,
      };
    case UPDATE_PRODUCT_FAILED:
      return {
        ...state,
        producLoader: false,
        updateProducLoader: false,
      };
      
    default:
      return state;
  }
};
